<div class="h-full py-5 px-7">
    <app-ongletlayout
        [ongletLinks]="tableLinkForParameters"
        [title]="'Administration'"
        storageId="administration"
    >
        <div>
            <router-outlet></router-outlet>
        </div>
    </app-ongletlayout>
</div>